import { useLocation } from 'react-router-dom';

interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

const BASE_URL = 'https://blue-nav.example.com';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '蓝色导航发布页',
  url: BASE_URL,
  description: '专业的内容发布与网站导航平台，提供高效便捷的发布管理工具。',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+86-400-888-6666',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '蓝色导航发布页',
  url: BASE_URL,
  description: '专业的内容发布与网站导航平台，提供高效便捷的发布管理工具。',
  inLanguage: 'zh-CN',
};

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const location = useLocation();
  const currentUrl = `${BASE_URL}${location.pathname}`;

  let schema = {};

  switch (type) {
    case 'Organization':
      schema = organizationSchema;
      break;
    case 'WebSite':
      schema = websiteSchema;
      break;
    case 'WebPage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: data?.name || '蓝色导航发布页',
        url: currentUrl,
        description: data?.description || '',
        inLanguage: 'zh-CN',
        isPartOf: {
          '@type': 'WebSite',
          name: '蓝色导航发布页',
          url: BASE_URL,
        },
      };
      break;
    case 'BreadcrumbList':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: (data?.items as Array<{ name: string; url: string }>)?.map((item, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: item.name,
          item: item.url,
        })),
      };
      break;
    case 'Article':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: data?.headline || '',
        description: data?.description || '',
        author: {
          '@type': 'Organization',
          name: data?.author || '蓝色导航编辑部',
        },
        datePublished: data?.datePublished || '',
        dateModified: data?.dateModified || data?.datePublished || '',
        image: data?.image || '',
        publisher: {
          '@type': 'Organization',
          name: '蓝色导航发布页',
        },
        inLanguage: 'zh-CN',
      };
      break;
    case 'FAQPage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: (data?.questions as Array<{ question: string; answer: string }>)?.map((q) => ({
          '@type': 'Question',
          name: q.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: q.answer,
          },
        })),
      };
      break;
    default:
      break;
  }

  if (!schema || Object.keys(schema).length <= 2) {
    return null;
  }

  return (
    <script type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  );
}